import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import Config from '../../commons/config/Config.js'
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'
import Security from '../../commons/security/Security.js'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import LocaleFormat from '../../commons/utils/LocaleFormat.js'
import $ from 'jquery'
import moment from 'moment'
import 'moment/min/locales'
import DataTable from 'datatables.net-bs4'
import 'datatables.net-bs4/css/dataTables.bootstrap4.css'
import 'datatables.net-autofill-bs4'
import 'datatables.net-buttons-bs4'
import 'datatables.net-buttons/js/buttons.colVis.js'
import 'datatables.net-buttons/js/buttons.flash.js'
import 'datatables.net-buttons/js/buttons.html5.js'
import 'datatables.net-buttons/js/buttons.print.js'
import 'datatables.net-colreorder-bs4/css/colReorder.bootstrap4.min.css'
import 'datatables.net-fixedcolumns-bs4/css/fixedColumns.bootstrap4.min.css'
import 'datatables.net-fixedheader-bs4/css/fixedHeader.bootstrap4.min.css'
import 'datatables.net-keytable-bs4/css/keyTable.bootstrap4.min.css'
import 'datatables.net-responsive-bs4'
import 'datatables.net-rowgroup-bs4/css/rowGroup.bootstrap4.min.css'
import 'datatables.net-rowreorder-bs4/css/rowReorder.bootstrap4.css'
import 'datatables.net-scroller-bs4/css/scroller.bootstrap4.min.css'
import 'datatables.net-select-bs4/css/select.bootstrap4.min.css'
import '../../assets/css/vec-datatables.css'
import datatablesConfig from '../../commons/datatables/DatatablesConfig.js'
import jzip from 'xlsx/dist/jszip'
import 'xlsx/dist/xlsx.full.min.js'
import LogoCompany from '../../assets/images/logo-company.png'
import LogoVecFleet from '../../assets/images/logo-vecfleet.png'
import LimpiarFiltros from '../../assets/images/limpiar-filtros.svg'
import swal2 from 'sweetalert2'
import swal from 'sweetalert'
import {FormattedMessage, injectIntl} from 'react-intl';
import VencimientosImportar from './VencimientosImportar.js'
import VencimientosImportarReporte from './VencimientosImportarReporte.js'

$.DataTable = DataTable;
window.JSZip = jzip;
var pdfMake = require('pdfmake/build/pdfmake.js');
var pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;


class VencimientosGrid extends Component {
	constructor(props) {
		super(props);

		this.ajaxHandler = new AjaxHandler();

		this.columnsToPrint = [1,2,3,4,5];
		moment.locale('es');

		this.state = {
			redirectTo: null,
			disableGenerar: false,
			reporteImportacion: true
		}
		
		this.handleCloseModal = this.handleCloseModal.bind(this);
		this.handleCancelModal = this.handleCancelModal.bind(this);
		this.handleReportCloseModal = this.handleReportCloseModal.bind(this);
	}
	componentDidMount(nextProps, nextState) {
		if(Security.hasPermission('VENCIMIENTOS_LISTAR')) {
	      this.ajaxHandler.subscribe(this);
				this.initGrid();
	    } else {
		    	this.setState({
		        redirectTo: '/error'
	      	});
	    }
	}

	componentWillUnmount() {
		this.ajaxHandler.unsubscribe();
		$('div.tooltip[role="tooltip"]').tooltip('dispose');
		$('div.tooltip[role="tooltip"]').remove();
		if(this.table) this.table.destroy();
	}

	handleNew(event) {
		this.setState({
			redirectTo: this.props.match.url + '/add'
		});
	}

	handleGenerarTickets(){
		this.setState({
      loading: true,
			disableGenerar: true
    }, () => {
      let component = this;

      this.ajaxHandler.fetch('/vencimientos/generar-desde-controles', {
        method: 'POST',
      }).then(response => {
        if(response.status === 400) {
          response.json()
          .then(data => {
            this.setState({
              errors: data.detalle
            });
          });
        } else {
			component.table.ajax.reload(null, false);
			swal(component.props.intl.formatMessage({ id: 'vencimientosGrid.modal_generarTickets.information_proceso_finalizado_con_exito', defaultMessage: 'PROCESO FINALIZADO CON ÉXITO!' }), "", "success");
		}
        window.scrollTo(0,0);
      }).catch((error) => {
        component.ajaxHandler.handleError(error);
      }).finally(() => {
        component.setState({
					loading: false,
					disableGenerar: false
				});
      });
    });
	}

	handleCancelModal(message, subtitle, error) {
		$("#import_vencimientos").modal('toggle');
		}
	
	handleCloseModal(importDetails, swalTitle , swalMessage, swalIcon = "info") {
		$("#import_vencimientos").modal("toggle");

		if (importDetails){
			if (importDetails.filas_fallaron && importDetails.filas_fallaron.length > 0) {			
				this.setState({
					reporteImportacion: importDetails.filas_fallaron,
				}, () => {
					$('#import_vencimientos_report_modal').modal({ backdrop: 'static' })
						$('#import_vencimientos_report_modal').on('hidden.bs.modal', () => {
							
							$('#import_vencimientos_report_modal').off('hidden.bs.modal');
							
							if(importDetails.filas_exitosas > 0) {
								swal(swalTitle, swalMessage, swalIcon).then(() => { this.table.ajax.reload() });
							}
						});
				});
			} else {
				swal(swalTitle, swalMessage, swalIcon).then(() => { this.table.ajax.reload() });
			}
		} else {
			// Descaarga Planilla Modelo
			swal(swalTitle, swalMessage, swalIcon);
		}
		
	}

	handleReportCloseModal(){
		$("#import_vencimientos_report_modal").modal('toggle');
		this.table.ajax.reload();
	}
	render() {
		// Verificar si la configuración de transportadora está activa
		const showTransportadora = ConfigBusiness.get('moviles.transportadora.grilla') === 'true';

		return (
			<React.Fragment>
				{this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
				<div className="row mt-2">
					<div className="col-12">
						<div className="card">
							<div className="card-content collpase show">
								<div className="card-body card-dashboard">
									<div className="container-fluid">
										<div className="row dt-icons">
											<div className="col-6">
												{Security.renderIfHasPermission('VENCIMIENTOS_CREAR', (
												<div className="btn btn-primary box-shadow-2 btn-round btn-lg btn-dt-main round-icon" onClick={this.handleNew.bind(this)} data-toggle="tooltip" data-placement="right" title={this.props.intl.formatMessage({ id: 'vencimientosGrid.render.button_add.title_nuevo', defaultMessage: 'Nuevo' })}>
													<i className="ft-plus"></i>
												</div>
												))}
												{Security.renderIfHasPermission('VENCIMIENTOS_GENERAR', (
												<div style={{display: (this.state.disableGenerar || !Security.isInternal())? 'none' : ''}} className="btn btn-primary box-shadow-2 btn-round btn-lg btn-dt-main round-icon" onClick={this.handleGenerarTickets.bind(this)} data-toggle="tooltip" data-placement="right" title={this.props.intl.formatMessage({ id: 'vencimientosGrid.render.generate_tickets.title_generar_tickets', defaultMessage: 'Generar Tickets' })}>
													<i className="ft-play"></i>
												</div>
												))}
											</div>
											<div className="col-6" id="buttons"></div>
										</div>
									</div>
									<div className="table-responsive">
										<table id="dataTableVencimientosGrid" className="table nowrap server-side table-hover" ref="grid" width="100%">
											<tfoot>
												<tr style={{backgroundColor: '#fff'}}>
													<th className="p-0"></th>
                          <th className="dt-search-header"></th>
													<th className="p-0"></th>
													{showTransportadora && <th className="dt-search-header"></th>}
                          <th className="dt-search-header"></th>
													<th className="dt-search-header"></th>
													<th className="dt-search-header"></th>
													<th className="dt-search-header"></th>
													<th className="dt-search-header"></th>
													<th className=""></th>
												</tr>
											</tfoot>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* Modal importador de vencimientos  */}
				<div className="modal fade" tabIndex="-1" id="import_vencimientos" role="dialog" aria-labelledby="myImportarVencimientoModalLabel1" style={{ margin: "auto" }}>
				<div className="modal-xl modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-header bg-fleet">
							<h4 className="modal-title text-white" id="myImportarVencimientoModalLabel1">
								<FormattedMessage id="vencimientosGrid.tools_import.importar_vencimientos" defaultMessage="Importar Vencimientos"/>
							</h4>
							<button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
						</div>
						<div className="modal-body">
							<form className="form">
								{<VencimientosImportar callbackClose={this.handleCloseModal} callbackCancel={this.handleCancelModal}/>}
							</form>
						</div>
					</div>
				</div>				
			</div>
			{/* Modal reporte  importar vencimientos */}
			<div className="modal fade" tabIndex="-1" id="import_vencimientos_report_modal" role="dialog" aria-labelledby="myImportReportLabel" style={{ margin: "auto" }}>
				<div className="modal-xl modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-header bg-fleet">
							<h4 className="modal-title text-white" id="myImportReportLabel">Reporte de la Importación</h4>
							<button type="button" className="close" onClick={this.handleReportCloseModal} aria-label="Close"><span aria-hidden="true">&times;</span></button>
						</div>
						<div className="modal-body modal-grey modal-mh ovf-x-hidden">
							{this.state.reporteImportacion ?
							<VencimientosImportarReporte data={this.state.reporteImportacion} callbackClose={this.handleReportCloseModal}></VencimientosImportarReporte	>
							: null}
						</div>
						<div className="modal-footer modal-grey">
							<button type="button" className="btn btn-default btn-fleet" onClick={this.handleReportCloseModal}>Ok</button>
						</div>
					</div>
				</div>
			</div>
			</React.Fragment>
		);
	}

	initGrid() {
		window.scrollTo(0, 0);
		let component = this;

		// Verificar si la configuración de transportadora está activa
		const showTransportadora = ConfigBusiness.get('moviles.transportadora.grilla') === 'true';

		// Actualizar columnsToPrint según si se muestra transportadora o no
		// Columnas: id(0), base(1), estado(2), [transportadora(3)], servicio, número, entidad, fechaVencimiento, ticket
		this.columnsToPrint = showTransportadora ? [1,2,3,4,5,6,7,8] : [1,2,3,4,5,6,7];

		// Preparar las promesas de datos
		let promises = [
			this.getData('/servicios/tipo-ticket/VENCIMIENTO&&GESTORIA/select'),
			this.getData('/bases/select-filtered-by-user/vencimiento'),
		];

		// Si la configuración está activa, agregar la promesa de transportadoras
		if (showTransportadora) {
			promises.push(this.getData('/transportadoras/select'));
		}

		Promise.all(promises).then((data) => {
			let filters = {
				servicio: data[0] ? data[0] : [],
				base: data[1] ? data[1] : []
			};

			// Si la configuración está activa, agregar las transportadoras a los filtros
			if (showTransportadora) {
				// Transformar los datos de transportadora al formato esperado {value, label}
				// Usar el nombre como value porque la función render devuelve el nombre para el filtro
				filters.transportadora = data[2] ? data[2].map(t => ({
					value: t.label || t.nombre,
					label: t.label || t.nombre
				})) : [];
			}

			this.table = $(this.refs.grid).DataTable(
				Object.assign({
					dom: 'r<t><"row mt-2"<"col-4" l><"col-4 text-center" i><"col-4" p>>',
					stateSave: true,
					stateSaveCallback: function(settings, data) {
						localStorage.setItem('DataTables_VencimientosGrid', JSON.stringify(data));
					},
					stateLoadCallback: function(settings) {
						return JSON.parse(localStorage.getItem('DataTables_VencimientosGrid'));
					},
					processing: true,
					serverSide: true,
					ajax: {
						type: 'GET',
						url: Config.get('apiUrlBase') + '/vencimientos/grid',
						headers: {
							'Authorization-Token': localStorage.getItem("token")
						},
						dataSrc: function(response) {
							return response.data;
						},
						error: function(xhr, error, thrown) {
							component.ajaxHandler.handleResponseErrorsIsValid(xhr);
						},
						cache: false
					},
					initComplete: function(settings) {
						let stateColumns = JSON.parse(localStorage.getItem('DataTables_VencimientosGrid')).columns;

						var sets = settings;
						var index = 0;

						this.api().columns().every(function() {
							var column = this;

							if (sets.aoColumns[index].filterType) {
								if (sets.aoColumns[index].filterType === 'select') {
									var select = $('<select class="btn-dt-filter" required><option value="" selected>'+component.props.intl.formatMessage({ id: 'vencimientosGrid.columns_searh_filter.buscar', defaultMessage: 'Buscar...' })+'</option></select>')
										.appendTo($(column.footer()).empty())
										.on('change', function() {
											var val = $.fn.dataTable.util.escapeRegex($(this).val());
											column
												.search(val ? val : '', true, false)
												.draw();
										});
									if (filters && sets.aoColumns[index].name && filters[sets.aoColumns[index].name]) {
										filters[sets.aoColumns[index].name].map(e => {
											select.append('<option value="' + e.value + '">' + e.label + '</option>');
											return true;
										});
									} else {
										// Obtener valores únicos
										var uniqueItems = [];
										var uniqueKeys = {};
										
										column.data().each(function(d, j) {
											// Obtener el valor renderizado
											var displayValue = '';
											var filterValue = '';
											
											// Si es un objeto (como transportadora), extraer el nombre
											if (d && typeof d === 'object') {
												displayValue = d.nombre || d.descripcion || '';
												filterValue = d.id || '';
											} else {
												displayValue = d || '';
												filterValue = d || '';
											}
											
											// Solo agregar si tiene valor y no está repetido
											if (displayValue && !uniqueKeys[filterValue]) {
												uniqueKeys[filterValue] = true;
												uniqueItems.push({
													value: filterValue,
													label: displayValue
												});
											}
										});
										
										// Ordenar y agregar al select
										uniqueItems.sort(function(a, b) {
											return a.label.localeCompare(b.label);
										}).forEach(function(item) {
											select.append('<option value="' + item.value + '">' + item.label + '</option>');
										});
									}
									if (stateColumns && stateColumns[index].search.search) select.val(stateColumns[index].search.search);
								}
								if (sets.aoColumns[index].filterType === 'input') {
									var input = $('<input type="text" class="btn-dt-filter" placeholder="'+component.props.intl.formatMessage({ id: 'vencimientosGrid.columns_searh_filter.placeholder_buscar', defaultMessage: 'Buscar...' })+'" />');
									if (stateColumns && stateColumns[index].search.search) input.val(stateColumns[index].search.search);
									input.appendTo($(column.footer()).empty());
									input.on('keyup change', function() {
										if (column.search() !== this.value) {
											column
												.search(this.value)
												.draw()
												.ajax.reload(null, false);
										}
									});
								}
							}
							index++;
							return '';
						});

						$('tfoot tr').appendTo('#dataTableVencimientosGrid thead');
					},
					columns: [
						{
							title: '',
							className: 'd-none',
							filterType: 'none',
							name: 'id',
							data: 'id'
						},
						{
						name: 'base',
						title: component.props.intl.formatMessage({ id: 'vencimientosGrid.column_profile.label_base', defaultMessage: 'Base' }),
						className: 'all',
						data: 'base',
						render: function(data, type, row) {
							if (type === 'filter') {
								return data && data.id ? data.id : '';
							} else {
								return data && data.descripcion ? data.descripcion : '';
							}
						},
						filterType: 'select'
					}, {
						title: '',
						data: 'estado',
						width: 3,
						padding: 0,
						orderable: false,
						className: 'p-0 all',
						render: function(data, type, full, meta) {
							return '';
						},
						createdCell: function(td, cellData, rowData, row, col) {
							$('div.tooltip[role="tooltip"]').tooltip('dispose');
							$('div.tooltip[role="tooltip"]').remove();
							
							$(td).attr('data-togle', 'tooltip');
							$(td).attr('data-placement', 'top');
              $(td).tooltip();
              switch (cellData) {
                case 'OK':
                  $(td).addClass('status-green');
                  $(td).attr('title', component.props.intl.formatMessage({ id: 'vencimientosGrid.column_state.title_ok', defaultMessage: 'Ok' }));
                  break;
                case 'ALERTADO':
                  $(td).addClass('status-yellow');
                  $(td).attr('title', component.props.intl.formatMessage({ id: 'vencimientosGrid.column_state.title_alertado', defaultMessage: 'Alertado' }));
                  break;
                case 'VENCIMIENTO_CERCANO':
                  $(td).addClass('status-orange');
                  $(td).attr('title', component.props.intl.formatMessage({ id: 'vencimientosGrid.column_state.title_vencimiento_cercano', defaultMessage: 'Vencimiento Cercano' }));
                  break;
                case 'VENCIDO':
                  $(td).addClass('status-red');
                  $(td).attr('title', component.props.intl.formatMessage({ id: 'vencimientosGrid.column_state.title_vencido', defaultMessage: 'Vencido' }));
                  break;
                default:
                  $(td).addClass('status-grey');
                  $(td).attr('title', '');
                  break;
							}
						},
						filterType: 'none'
					},
					...(showTransportadora ? [{
						name: 'transportadora',
						title: component.props.intl.formatMessage({ id: 'vencimientosGrid.column_transportadora.label_transportadora', defaultMessage: 'Transportadora' }),
						className: 'all',
						data: 'transportadora',
						render: function(data, type, row) {
							if (type === 'filter') {
								return data && data.nombre ? data.nombre : '';
							} else {
								return data && data.nombre ? data.nombre : '';
							}
						},
						filterType: 'select'
					}] : []),
					{
						name: 'servicio',
						title: component.props.intl.formatMessage({ id: 'vencimientosGrid.column_service.label_servicio', defaultMessage: 'Servicio' }),
						className: 'all',
						data: 'servicio',
						render: function(data, type, row) {
							if (type === 'filter') {
								return data && data.id ? data.id : '';
							} else {
								return data && data.nombre ? data.nombre : '';
							}
						},
						filterType: 'select'
					}, {
						title: component.props.intl.formatMessage({ id: 'vencimientosGrid.column_number.label_numero', defaultMessage: 'Número' }),
						className: 'all',
						data: 'numero',
						filterType: 'input'
					}, {
						title: component.props.intl.formatMessage({ id: 'vencimientosGrid.column_entity.label_entidad', defaultMessage: 'Entidad' }),
						className: 'all',
            data: 'movilPersona',
            render: function(data, type, row) {
							if (type === 'filter') {
								return data && data.id ? data.id : '';
							} else {
								return data && data.descripcion ? data.descripcion : '';
							}
						},
						filterType: 'input'
					}, {
						name: 'fechaVencimiento',
						title: component.props.intl.formatMessage({ id: 'vencimientosGrid.column_expiration.label_vencimiento', defaultMessage: 'Vencimiento' }),
						className: 'all',
						data: 'fechaVencimiento',
						render: function(data, type, full, meta) {
							return data ? LocaleFormat.formatDate(data) : '';
						},
						filterType: 'input'
					}, {
						name: 'ticket',
						title: component.props.intl.formatMessage({ id: 'vencimientosGrid.column_ticket.label_ticket', defaultMessage: 'Ticket' }),
						className: 'all',
						data: 'ticket',
						render: function(data, type, row) {
							return data && data ? Math.floor(data) : '';
						},
						filterType: 'input'
					}, {
						orderable: false,
						data: null,
						className: "text-center all",
						width: '120px',
						render: function(data, type, full, meta) {
							let forzar = true;
							let estadosActivos = ConfigBusiness.get('moviles.estadosActivos') || '';
							if ((full.movilPersona.tipo=="MOVIL" && estadosActivos.indexOf(full.movilPersona.estado)==(-1)) || (full.movilPersona.estado===false)) {
								forzar = false;
							}
							let html =
								((Security.hasPermission('VENCIMIENTOS_FORZAR') && forzar) ? `
								<button class="action forzar btn btn-sm btn-icon btn-dt-grid text-success" ` + (full.ticket ? ` style="visibility: hidden;"` : `` ) +  ` data-title="`+component.props.intl.formatMessage({ id: 'vencimientosGrid.column_actions.button_title_forzar', defaultMessage: 'Forzar' })+`" data-togle="tooltip" data-placement="top">
									<i class="fa fa-crosshairs fa-2x"></i>
								</button>` : `
								<button class="action btn btn-sm btn-icon btn-dt-grid text-success" ` + (` style="visibility: hidden;"`) +  ` data-togle="tooltip" data-placement="top">
									<i class="fa fa-crosshairs fa-2x"></i>
								</button>`) +
								(Security.hasPermission('VENCIMIENTOS_VISUALIZAR') ? `
								<button class="action view btn btn-sm btn-icon btn-dt-grid text-success" data-title="`+component.props.intl.formatMessage({ id: 'vencimientosGrid.column_actions.button_title_ver', defaultMessage: 'Ver' })+`" data-togle="tooltip" data-placement="top">
									<i class="fa fa-search fa-xs"></i>
								</button>` : '') +
								((Security.hasPermission('VENCIMIENTOS_MODIFICAR') && data.ticket == 0) ? `
								<button class="action edit btn btn-sm btn-icon btn-dt-grid text-success" data-title="`+component.props.intl.formatMessage({ id: 'vencimientosGrid.column_actions.button_title_editar', defaultMessage: 'Editar' })+`" data-togle="tooltip" data-placement="top">
									<i class="fa fa-pencil fa-xs"></i>
								</button>` : '') +
								((Security.hasPermission('VENCIMIENTOS_ELIMINAR') && data.ticket == 0)? `
								<button class="action delete btn btn-sm btn-icon btn-dt-grid text-danger" data-title="`+component.props.intl.formatMessage({ id: 'vencimientosGrid.column_actions.button_title_eliminar', defaultMessage: 'Eliminar' })+`" data-togle="tooltip" data-placement="top">
									<i class="ft ft-trash"></i>
								</button>` : '');
							return html;
						},
						createdCell: function(td, cellData, rowData, row, col) {
							$(td).find('button').tooltip();
						},
						filterType: 'none'

					}],
					drawCallback: function() {
						$(this).find('.action').on('click', function() {
							let data = component.table.row($(this).parents('tr')).data();
							let redirectTo;
							if ($(this).hasClass('view')) redirectTo = component.props.match.url + '/' + data.id;
							if ($(this).hasClass('edit')) redirectTo = component.props.match.url + '/' + data.id + '/edit';
							if ($(this).hasClass('forzar')) {
								swal2({
									input: 'textarea',
									inputPlaceholder: component.props.intl.formatMessage({ id: 'vencimientosGrid.modal_forzado.placeholder_ingrese_detalle_acerca_razon_forzado', defaultMessage: 'Por favor, ingrese un detalle acerca de la razón del forzado' }),
									showCancelButton: true,
									cancelButtonText: component.props.intl.formatMessage({ id: 'vencimientosGrid.modal_forzado.button_cancelar', defaultMessage: 'Cancelar' }),
									confirmButtonText: component.props.intl.formatMessage({ id: 'vencimientosGrid.modal_forzado.button_ok', defaultMessage: 'Ok' }),
									inputValidator: function(value) {
										return !value && component.props.intl.formatMessage({ id: 'vencimientosGrid.modal_forzado.erros_campo_requerido', defaultMessage: 'Campo requerido' });
									}
								}).then((result) =>{
									if(result.value) {
										component.ajaxHandler.fetch('/vencimientos/forzar/' + data.id , {
											method: 'POST',
											body: JSON.stringify({
												detalle: result.value
											}),
										}).then(response => {
											if(response.status === 204) {
												component.table.ajax.reload(null, false);
												swal(component.props.intl.formatMessage({ id: 'vencimientosGrid.modal_forzado.information_forzado_exitoso', defaultMessage: 'Forzado exitoso!' }), "", "success");
											} else {
												response.json()
												.then(data => {
													component.setState({
														errors: data.detalle
													});
												});
											}
											window.scrollTo(0,0);
										}).catch((error) => {
											component.ajaxHandler.handleError(error);
										});
									}
								});
							}
							component.setState({
								redirectTo: redirectTo
							});
							if ($(this).hasClass('delete')) {
								swal({
									title: component.props.intl.formatMessage({ id: 'vencimientosGrid.modal_delete.confirm_eliminacion', defaultMessage: '¿Confirma la eliminación?' }),
									text: null,
									icon: "warning",
									buttons: {
										confirm: {
											text: component.props.intl.formatMessage({ id: 'vencimientosGrid.modal_delete.confirm_eliminacion.si', defaultMessage: 'Si' }),
											value: true,
											visible: true,
											className: "btn btn-primary",
											closeModal: false
										},
										cancel: {
											text: component.props.intl.formatMessage({ id: 'vencimientosGrid.modal_delete.confirm_eliminacion.no', defaultMessage: 'No' }),
											value: null,
											visible: true,
											className: "btn btn-danger",
											closeModal: true,
										}
									}
								}).then((isConfirm) => {
										if (isConfirm) {
											fetch(Config.get('apiUrlBase') + '/vencimientos/' + data.id, {
													method: 'DELETE',
													headers: {
														'Accept': 'application/json',
														'Content-Type': 'application/json',
														'Authorization-Token': localStorage.getItem("token")
													}
												})
												.then(function(response) {
													component.table.ajax.reload(null, false);
													swal(component.props.intl.formatMessage({ id: 'vencimientosGrid.modal_delete.information_eliminado', defaultMessage: 'Eliminado!' }), "", "success");
												})
												.catch(function(error) {
													swal(component.props.intl.formatMessage({ id: 'vencimientosGrid.modal_delete.information_error', defaultMessage: 'Error' }), "", "error");
												});
									}
								});
							}
						});
					}
				}, datatablesConfig)
			);

			new $.fn.dataTable.Buttons(this.table, {
				buttons: [{
					name: 'filterReset',
					text: '<img id="filterReset" class="filter-reset" src="'+LimpiarFiltros+'"></i>',
					titleAttr: 'Restaurar filtros y ordenamiento',
					action: function (e, dt, node, config) {
						var index = 0;
						component.table.columns().every(function() {
							var column = this;

							if (dt.settings()[0].aoColumns[index].filterType) {
								column.search('', true, false);
							}
							index++;
							return null;
						});
						$(dt.table().node()).find('thead tr th *[class$="-filter"]').each((index, element) => {
							$(element).val('');
						});
						dt.table().order([ 0, 'asc' ]);
						dt.ajax.reload();
					}
				}, {
					extend: 'print',
					name: 'print',
					text: '<i class="ft-printer"></i>',
					title: '',
					customize: function(win) {
						var css = '@page { size: landscape; }',
							head = win.document.head || win.document.getElementsByTagName('head')[0],
							style = win.document.createElement('style');

						style.type = 'text/css';
						style.media = 'print';

						if (style.styleSheet) {
							style.styleSheet.cssText = css;
						} else {
							style.appendChild(win.document.createTextNode(css));
						}

						head.appendChild(style);

						$(win.document.body)
							.css('font-size', '10pt')
							.prepend(`<div class="container">
												<div class="row mb-2">
													<div class="col-6">
														<img style="height: 40px" src="` + LogoCompany + `" />
													</div>
													<div class="col-6	text-right">
														<img style="height: 40px" src="` + LogoVecFleet + `" />
													</div>
												</div>
												<div class="row mb-2">
													<div class="col-12" style="border-bottom: 1px solid #000;">
														<h2>`+component.props.intl.formatMessage({ id: 'vencimientosGrid.print_content.header_listado_de_vencimientos', defaultMessage: 'Listado de Vencimientos' })+`</h2>
													</div>
												</div>
											</div>`);

						$(win.document.body).find('table')
							.addClass('compact')
							.css('font-size', 'inherit');
					},
					exportOptions: {
						columns: component.columnsToPrint
					},
					titleAttr: component.props.intl.formatMessage({ id: 'vencimientosGrid.tools_print.title_imprimir', defaultMessage: 'Imprimir' })
				}, 
				{
					name: 'exportExcel',
					text: '<i class="ft-upload"></i>',
					titleAttr: component.props.intl.formatMessage({ id: 'vencimientosGrid.tools_export.select_title_exportar', defaultMessage: 'Exportar' }),
					action: function(e, dt, node, config){
						swal({
							title: component.props.intl.formatMessage({ id: 'vencimientosGrid.tools_export.information_se_exportando_los_datos', defaultMessage: 'Se están exportando los datos.' }),
							text: component.props.intl.formatMessage({ id: 'vencimientosGrid.tools_export.information_esta_accion_puede_demorar', defaultMessage: 'Esta acción puede demorar' }),
							buttons: {}
						});

						component.ajaxHandler.fetch('/vencimientos/exportar-excel',{
							method: 'GET'
						}).then(response => {
							if(response.status === 200){
								return response.blob();
							}
						}).then(fileBlob => {
							let fileUrl = URL.createObjectURL(fileBlob);
							$("<a />", {
								href: fileUrl,
								download: "fleet-vencimientos.xlsx"
							}).appendTo("body").get(0).click();
						}).catch(() => {
						}).finally(() => {
							swal.close();
						});
					}
				},
				{
					text: '<i class="ft-download"></i>',
					className: Security.hasPermission('VENCIMIENTOS_IMPORTAR') ? 'all': 'd-none',
					titleAttr: component.props.intl.formatMessage({ id: 'vencimientosGrid.tools_import.select_importar_vencimientos', defaultMessage: 'Importar' }),
						action: function (e, dt, node, config) {
							$('#import_vencimientos').modal({ backdrop: 'static' }).addClass('modal-moviles-dropdown');
						}
					}
			],
							
			});

			this.table.buttons(0, null).container().appendTo('#buttons');

			this.table.button('filterReset:name')
				.nodes()
				.attr('data-toggle', 'tooltip')
				.attr('data-position', 'top');
			this.table.button('print:name')
				.nodes()
				.attr('data-toggle', 'tooltip')
				.attr('data-position', 'top');
			this.table.button('columns:name')
				.nodes()
				.attr('data-toggle', 'tooltip')
				.attr('data-position', 'top');
			this.table.button('export:name')
				.nodes()
				.attr('data-toggle', 'tooltip')
				.attr('data-position', 'top');
			$('[data-toggle="tooltip"]').tooltip();

			$('.buttons-collection').on("click",function(e){ e.stopPropagation();
				if($('.dt-button-collection>.dropdown-menu').css('display')=='none')
					$('.dt-button-collection>.dropdown-menu').css('display','block');
			});
		}).catch(function(error) {
			component.ajaxHandler.handleError(error);
		}).finally(() => {
			component.setState({
				loading: false
			});
		});
	}

	getData(service) {
		let serviceURL = Config.get('apiUrlBase') + service;
		return fetch(serviceURL, {
			method: 'GET',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization-Token': localStorage.getItem("token")
			}
		})
		.then(response => {
			return this.ajaxHandler.handleResponseErrorsIsValid(response) ? response.json() : null;
		});
	}
}

export default injectIntl(VencimientosGrid);
